module.exports = __webpack_public_path__ + "img/tattoo.d3085b31.jpg";